import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Button, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

import styles from './styles'

const DialogConfirm = ({
   open,
   onCancel,
   onConfirm,
   children,
   title,
   contextText,
   btnConfirmDisabled = false,
   btnCancelDisabled = false,
   btnConfirmText = 'Confirmar',
   btnCancelText = 'Cancelar',
   showCloseButton = false,
   fullWidth = false,
   maxWidth = 'sm',
 }) => {
  const classes = styles()

  const handleConfirm = (event) => {
    event.stopPropagation()

    if (onConfirm) {
      onConfirm(event)
    }
  }

  const handleCancel = (event) => {
    event.stopPropagation()

    if (onCancel) {
      onCancel(event)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-content"
      disableEscapeKeyDown={true}
      onClick={(e) => e.stopPropagation()}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      sx={
        maxWidth === 'custom'
          ? {
              '& .MuiDialog-container': {
                '& .MuiPaper-root': {
                  width: '100%',
                  maxWidth: 1000,
                },
              },
            }
          : {}
      }
    >
      <DialogTitle className={classes.dialogTitle}>
        {title}
        {showCloseButton && (
          <IconButton
            aria-label="close"
            onClick={handleCancel}
            className={classes.dialogCloseButton}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        {contextText && (
          <DialogContentText id="alert-dialog-content">
            {contextText}
          </DialogContentText>
        )}
        {_.isString(children) && !contextText ? (
          <DialogContentText id="alert-dialog-content">
            {children}
          </DialogContentText>
        ) : (
          children
        )}
      </DialogContent>
      <DialogActions>
        {onCancel && (
          <Button
            onClick={handleCancel}
            disabled={btnCancelDisabled}
            variant="text"
          >
            {btnCancelText}
          </Button>
        )}

        {onConfirm && (
          <Button
            style={{ margin: "1.2rem" }}
            onClick={handleConfirm}
            disabled={btnConfirmDisabled}
            autoFocus={true}
            variant="contained"
          >
            {btnConfirmText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

DialogConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.node.isRequired,
  contextText: PropTypes.node,
  btnConfirmDisabled: PropTypes.bool,
  btnCancelDisabled: PropTypes.bool,
  btnConfirmText: PropTypes.string,
  btnCancelText: PropTypes.string,
  showCloseButton: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false, 'custom']),
    PropTypes.string,
  ]),
}

DialogConfirm.defaultProps = {
  onCancel: null,
  onConfirm: null,
  children: null,
  contextText: null,
  btnConfirmDisabled: false,
  btnCancelDisabled: false,
  btnConfirmText: 'Confirmar',
  btnCancelText: 'Cancelar',
  showCloseButton: false,
  fullWidth: false,
  maxWidth: 'sm',
}

export default DialogConfirm
